<div class="container">
  <div class="row mt-3">
    <div class="col-md-3 col-lg-2">

      <a (click)="getModalEmail()" class="btn btn-danger btn-sm btn-block" style="color: #fff;" role="button">
        <span>COMPOSE</span>
      </a>

      <hr>
      <ul class="nav flex-column nav-stacked ">

        <li class=" nav-item " [class.active]="isActive">
          <a (click)="receivedMails()" class="nav-link" id="profile-tab" data-toggle="tab" href="#home" role="tab"
            aria-controls="profile" aria-selected="false">
            <span class="badge  badge-pill pull-right ">{{recievedlength}}</span>MailBox</a>
        </li>

        <li class=" nav-item" [class.active]="isActive">
          <a class="nav-link" id="contact12-tab" (click)="sentMails()" data-toggle="tab" href="#send" role="tab"
            aria-controls="contact" aria-selected="false"><span
              class="badge  badge-pill pull-right ">{{mySendLength}}</span>send </a>
        </li>

      </ul>
    </div>
    <div class="col-md-9 col-lg-10">
      <!--search area-->
      <div class="ui-widget-header search-area">
        <div class="master-form">
          <app-fast-search [preventDefault]="true" [appearFastSearch]="false" [appCodes]="[2005,2006,1018]"
            name="fastSearchData" (searchKeys)="onSearchClick($event)" ngDefaultControl></app-fast-search>
        </div>
      </div>
      <!--search area-->
      <!-- Tab panes -->
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" *ngIf="showReciveFlag==1" role="tabpanel"
          aria-labelledby="home-tab">
          <div class="list-group" *ngFor="let maildata of myMails ">
            <a class="list-group-item">
              <span class="name" style="min-width: 120px; margin-top: 5px; font: 19px bold;
                                display: inline-block;">
                {{ 'SENDERNAME' | translate }} :{{maildata.senderNameAr}}
              </span>
              <br>

              <span class="name" style="min-width: 120px; margin-top: 5px; font: 19px bold;
                                display: inline-block; ">
                {{ 'HEADER' | translate }} :{{maildata.subject}}
              </span>

              <span class="badge  badge-pill float-left mr-2">
                {{ 'SENDDATE' | translate }} :{{maildata.regDate}}
              </span>
              <br>

              <span class="text-muted" style="font-size: 17px;color: #555; margin-top:5px">
                {{maildata['content']}}
                <a *ngIf="!maildata['isContentToggled']&&maildata['message'].length>200"
                  (click)="toggleContent(maildata)" i18n style="color: blue;">Read More</a>
                <a *ngIf="maildata['isContentToggled']&&maildata['message'].length>200"
                  (click)="toggleContent(maildata)" i18n style="color: blue;">Read Less</a>

              </span>
              <br>
              <ng-template ngFor let-file [ngForOf]="maildata.attachments">
                <span class="float-left cursor-pointer px-1 text-primary" *ngIf="file?.docPath" [title]="file?.docPath"
                  (click)="downloadURI(file.filePath, file.docPath)">
                  {{file.docPath}}
                  <span class="fas fa-paperclip" [attr.filePath]="file.filePath"></span>
                </span>
              </ng-template>
            </a>
          </div>
        </div>


        <div class="tab-pane fade show active" id="send" *ngIf="showReciveFlag!=1" role="tabpanel"
          aria-labelledby="home-tab">
          <div class="list-group" *ngFor="let maildata of myMails ">
            <a class="list-group-item">

              <span class="name" style="min-width: 120px; margin-top: 5px; font: 19px bold;
                                display: inline-block;">
                {{ 'RECEIVERNAME' | translate }} :{{maildata.reciverNameAr}}
              </span>
              <br>

              <span class="name" style="min-width: 120px; margin-top: 5px; font: 19px bold;
                                display: inline-block; ">
                {{ 'HEADER' | translate }} :{{maildata.subject}}
              </span>


              <span class="badge  badge-pill float-left mr-2">
                {{ 'SENDDATE' | translate }} :{{maildata.regDate}}</span>
              <br>

              <span class="text-muted" style="font-size: 17px;color: #555; margin-top:5px">
                {{maildata['content']}}
                <a *ngIf="!maildata['isContentToggled']&&maildata['message'].length>200"
                  (click)="toggleContent(maildata)" i18n style="color: blue;">Read More</a>
                <a *ngIf="maildata['isContentToggled']&&maildata['message'].length>200"
                  (click)="toggleContent(maildata)" i18n style="color: blue;">Read Less</a>
              </span>
              <br>

              <ng-template ngFor let-file [ngForOf]="maildata.attachments">
                <span class="float-left cursor-pointer px-1 text-primary" *ngIf="file?.docPath" [title]="file?.docPath"
                  (click)="downloadURI(file.filePath, file.docPath)">
                  {{file.docPath}}
                  <span class="fas fa-paperclip" [attr.filePath]="file.publishDocPath"></span>
                </span>
              </ng-template>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<block-modal-container #popup (close)="onpopupClose($event)">
  <ng-container class="modal-body" [ngComponentOutlet]="DynamicComponent"></ng-container>
</block-modal-container>
